<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 tabindex="0">Alterar Sala de Chat</h1>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome da Sala:">
                <b-input-group class="mb-3">
                  <b-form-input type="text"
                                class="form-control"
                                placeholder="Título"
                                autocomplete="titulo"
                                v-model="$v.form.titulo.$model"
                                :state="chkState('titulo')"
                                autofocus/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Nome é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="table-responsive" cols="12">
              <b-form-group label="Descrição:" :state="chkState('descricao')">
                <wysiwyg v-model="form.descricao" :state="chkState('descricao')"/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <h3><p style="text-align: center">Configurar Sala</p></h3>
            </b-col>
          </b-row>
          <b-row>
               <b-col sm="12" md="6">
                <b-form-group label="Usuarios inscritos:">
                    <multiselect v-model="participante" :options="options_participantes"  placeholder="Selecione" label="text" track-by="text"></multiselect>
                </b-form-group>
              </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4">
              <b-button block variant="primary" @click="adcionarParticipante()">
                <i class="fa fa-plus"></i>&nbsp;&nbsp;<span>Adicionar</span>
              </b-button>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="12">
                  <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 10%">ID</th>
                      <th scope="col" style="width: 75%">Nome</th>
                      <th scope="col" style="width: 5%">Ação</th>
                    </tr>
                  </thead>
                  <tbody v-if="participantes.length > 0">
                    <tr class="action" v-for="(participante, index)  in participantes" :key="participante.id">
                      <td>{{participante.id}}</td>
                      <td>{{participante.nome}}</td>
                      <td>
                        <a class="btn btn-sm btn-secondary action" @click="removerParticipante(index)">
                          <i class="fa fa-times"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="9">Nenhum registro de usuários...</td>
                    </tr>
                  </tbody>
                  </table>
            </b-col>
        </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-checkbox
                v-model="config_resposta"
                name="checkbox-validation">Por Resposta
              </b-form-checkbox>
            </b-col>
            <b-col cols="12" v-if="config_resposta">
              <br>
            <b-row>
              <b-col cols="4">
                <b-form-group label="Selecione o formulario que deseja habilitar"  invalid-feedback='É obrigatório informar o formulário.'>
                      <b-form-select placeholder="" v-model.trim="form.formulario" class="mb-3" :options='options_formularios'>
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
              <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col">Pergunta</th>
                    <th scope="col">Resposta:</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="form.perguntas_alternativas.length > 0">
                  <tr class="action" v-for="(pergunta_alternativa, index) in form.perguntas_alternativas" :key="pergunta_alternativa.id">
                   <td>
                        <b-form-select @change="getRespostas($event, index)" v-model="pergunta_alternativa.perguntas_selecionadas" class="mb-3">  
                        <option selected :value="null">Selecione</option>                       
                        <option v-for="pergunta in perguntas" :key="pergunta.id" :value="pergunta.id">{{pergunta.titulo}}</option>
                        </b-form-select>
                      </td>
                      <td>
                        <b-form-select v-model="pergunta_alternativa.alternativas_selecionadas" class="mb-3">  
                        <option selected :value="null">Selecione</option>                        
                        <option v-for="alternativa in alternativas[index]" :key="alternativa.id" :value="alternativa.id">{{alternativa.resposta}}</option>
                        </b-form-select>
                      </td>
                    <td>
                      <b-form-radio-group v-model="pergunta_alternativa.comentar" :options="options_perfil" :name="'option_perfil_' + index "/>
                    </td>
                        <td style="width: 8%">
                          <a class="btn btn-sm btn-secondary action" @click="adicionarPergunta()">
                            <i class="fa fa-plus"></i>
                          </a>
                          <a v-if="index > 0" class="btn btn-sm btn-secondary action" @click="removerPergunta(index)">
                            <i class="fa fa-minus"></i>
                          </a>
                      </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="3">Nenhum Resposta selecionado</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <hr>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading" md="4">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-pencil"></i>&nbsp;
              <span>Alterar Sala</span>
            </b-button>
          </b-col>
          <b-col v-else md="4">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/salachat')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
      }
    }
  },
  created () {
    if (!this.can('mocao.store')) {
      // this.$router.push('/')
    }
    this.loadFormularios()
    this.loadSalaChat()
    this.loadParticipantesConferencia()
  },
  data () {
    return {
      loading: false,
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      form: {
        titulo: '',
        descricao: '',
        perguntas_alternativas:[],
        formulario: null
      },
      config_resposta: false,
      options_formularios: [{value: null, text: 'Selecione'}],   
      options_perfil: [
        {'value': 'true', 'text': 'Visualizar e Comentar'},
        {'value': 'false', 'text': 'Somente Visualizar'}
      ],
      options_participantes: [],  
      perfil_selecionado: null,
      usuarios_selecionados: null,
      participante: null,
      participantes: [],
      perfis: [],
      estados: [],
      perguntas: [],
      alternativas: [],
      respostas: [],
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  watch: {
    'form.formulario': function () {      
       this.buscarPerguntasRespostas()
    },
    'pergunta_alternativa.perguntas_selecionadas': function (){
      this.alternativas = this.perguntas[this.perguntas_selecionadas]['opcoes_perguntas_dependentes']
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    loadFormularios () {
      Vue.http.get('api/formulario/listar/' + this.conferencia_id + '/' + true).then(response => {
        if (response.body.success) {
          let formularios = response.body.data.data                   
          for (let i = 0; i < formularios.length; i++) {
            this.options_formularios.push({value: formularios[i].formulario_servico_id, text: formularios[i].titulo})
          }
        }
      })
    },
    loadSalaChat () {
      // Carrega os estados
      Vue.http.get('api/salachat/' + this.$route.params.id).then(response => {
        let data = response.data.data

        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        this.form.formulario = data.formulario_id 
         
        if(data.respostas.length > 0){
          this.config_resposta = true
          this.respostas = data.respostas
        } 
        
        if(data.participante.length > 0){
          for (let i = 0; i < data.participante.length; i++) {
            this.participantes.push({
              id: data.participante[i].user_id,
              nome: data.participante[i].user.nome
            })
          }
        }
      })
    },
    loadParticipantesConferencia (){
      Vue.http.get('api/participante').then(response => {
        let data = response.body.data.data
        if(data.length > 0){
          for (let i = 0; i < data.length; i++) {
            this.options_participantes.push({value: data[i].user_id, text: data[i].nome})
          }
        }
      })
    },
    adcionarParticipante (){    
      if(!this.participante.value){
          this.erro('Selecione um usuário.')
          return false
      }
      for (let i = 0; i < this.participantes.length; i++) {
        if(this.participantes[i].id === this.participante.value){
          this.erro('O usuário já adicionado.')
          return false
        }
      }

      Vue.http.get('api/usuario/' + this.participante.value).then(response => {
        this.participantes.push({
          id: response.data.data[0].id,
          nome: response.data.data[0].nome
        })
      }) 
    },
    buscarPerguntasRespostas() {
      this.perguntas = []
      this.alternativas = []
      this.form.perguntas_alternativas = []
      if(this.form.formulario){
        Vue.http.get('api/formulario/buscarPerguntasRespostas/' + this.form.formulario).then(response => {
          if (response.body.success) {
            if(response.body.data.dados){              
              this.perguntas = response.body.data.dados
             
                if( this.respostas.length > 0){
                  for (let i = 0; i <  this.respostas.length; i++) {                                 
                    this.form.perguntas_alternativas.push({
                        id: null,
                        perguntas_selecionadas:  this.respostas[i].pergunta_id,
                        alternativas_selecionadas:  this.respostas[i].alternativa_id,
                        comentar: this.respostas[i].comentar               
                      })  

                      this.getRespostas(this.respostas[i].pergunta_id, i)      
                  }  
            
                }else{                  
                  this.form.perguntas_alternativas.push({
                    id: null,
                    perguntas_selecionadas: [],
                    alternativas_selecionadas: [],
                    comentar: false
                  }) 
                }             
            }          
          }
        })   
      }   
    },
    adicionarPergunta () { 
      this.form.perguntas_alternativas.push({
        id: null,
        perguntas_selecionadas: [],
        alternativas_selecionadas: [],
        comentar: false
      })
    },
    getRespostas(event, index){   
      this.alternativas.splice(index, 0)
      this.alternativas[index] = this.perguntas[event]['opcoes_perguntas_dependentes']      
    },
    removerPergunta (key) {
      this.form.perguntas_alternativas.splice(key, 1)
    },
    removerParticipante (key){
      this.participantes.splice(key, 1)
    },
    salvar () {
      let form = this.$v.form
      let data = {
        titulo: form.titulo.$model,
        descricao: form.descricao.$model,
        respostas: this.form.perguntas_alternativas,
        formulario_id: this.form.formulario,
        participantes: this.participantes
      }

      this.loading = true
      Vue.http.put('api/salachat/' + this.$route.params.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/salachat'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 5000,
        appendToast: true,
        variant: 'danger'
      })
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/salaChat/SalaChatEditar.vue